const faqItems = document.querySelectorAll('.FaqTab .faq-item');
if (faqItems) {
    faqItems.forEach((item) => {
        const question = item.querySelector('.faq-question');
        const answer = item.nextElementSibling;
        const icon = item.querySelector('.icon-container');

        item.addEventListener('click', () => {
            faqItems.forEach((otherItem) => {
                if (otherItem !== item) {
                    const otherAnswer = otherItem.nextElementSibling;
                    const otherIcon = otherItem.querySelector('.icon-container');

                    otherAnswer.classList.remove('active');
                    otherIcon.classList.remove('active');
                }
            });
            
            answer.classList.toggle('active');
            icon.classList.toggle('active');
            // if (answer.classList.contains('active')) {
            //     answer.style.maxHeight = 512 + 'px';
            // } else {
            //     answer.style.maxHeight = '0';
            // }
        });
    });
}
